import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextInputComponent } from './components/text-input/text-input.component';
import { SelectInputComponent } from './components/select-input/select-input.component';
import { ChipInputComponent } from './components/chip-input/chip-input.component';
import { NgChartsModule } from 'ng2-charts';
import { DoughnutChartComponent } from './components/doughnut-chart/doughnut-chart.component';
import { OpenModalDirective } from './directives/open-model.directive';
import { AppMenuComponent } from './components/app-menu/app-menu.component';
import { UserPickerComponent } from './components/user-picker/user-picker.component';

const components = [
  TextInputComponent,
  SelectInputComponent,
  ChipInputComponent,
  DoughnutChartComponent,
  OpenModalDirective,
  AppMenuComponent,
  UserPickerComponent
];

const modules = [
  CommonModule,
  TranslateModule,
  RouterModule,
  ReactiveFormsModule,
  FormsModule,
  NgChartsModule
];

@NgModule({
  declarations: [...components],
  imports: [
    ...modules,
    NgxPermissionsModule.forChild()
  ],
  exports: [...modules, ...components]
})
export class SharedModule { }
